import { css } from 'linaria';

export const reviewCard = css`
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const reviewCardFirst = css`
  margin-top: 18px;
`;

export const reviewCardSkeletonView = css`
  width: 100%;
  height: 336px;
  margin-top: 48px;
  fill: var(--background-secondary);
`;

export const reviewAnswer = css`
  width: 100%;
  margin-top: var(--space-300);
`;

export const showMoreButton = css`
  display: block;
  width: 100%;
  margin-top: 48px;
`;

export const showMoreButtonSkeleton = css`
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  margin-top: 48px;
  background-color: var(--background-secondary);
  border-radius: 4px;
`;

export const showReviewPhotoBtn = css`
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
`;
